import { Component, Vue } from 'vue-property-decorator';

@Component
export default class NoAccessComponent extends Vue {
    public demoVar: boolean = true;

    // tslint:disable-next-line: no-empty
    public mounted() {

    }

    public goBack() {
        this.$router.replace({ name: 'dashboard' });
    }
}
